// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import CheckoutComplete from "../containers/CheckoutComplete";
import { useTranslation } from 'react-i18next';

export default function CheckoutView() {
    const { t } = useTranslation();
  return (
      <PageContainer title={t("Checkout Complete")} showShopToolbar={false}>
      <CheckoutComplete />
    </PageContainer>
  );
}
